/**
 * @author NikolaV
 */
import * as React from 'react';
import { cs } from '@shared/utils/utils-classname';
import { Tooltip } from '@shared/ui-react/Tooltip';


const tooltipModifiers = [{
    name: 'offset',
    enabled: true,
    options: {
        offset: [0, 13],
    },
}];

export class Button extends React.PureComponent<{
    icon?: string,
    iconPosition?: 'left' | 'right',
    iconSize?: number;

    onClick?: any,
    onContextMenu?: any,
    className?: string,
    tooltip?: string,
    title?: string,
    disabled?: boolean,
    loading?: boolean,
    children?: any
    id?: string;
    style?: React.CSSProperties;
    element?: 'button' | 'div';
    type?: 'button' | 'submit';

    // style
    primary?: boolean,
    secondary?: boolean,
    subtle?: boolean,
    large?: boolean,
    small?: boolean,
}, {}> {
    public el: HTMLElement;

    render() {
        let { children, onClick, onContextMenu, tooltip, loading, disabled, icon, title, id, style, type, iconPosition } = this.props;
        iconPosition = iconPosition ?? 'left';

        const isDefault = !this.props.primary && !this.props.secondary && !this.props.className?.includes('button-');
        const isSubtle = isDefault ? false : this.props.subtle;
        const isSecondary = isDefault ? true : this.props.secondary;

        const classes = cs(
            this.props.className, {
                loading,
                disabled,
                'ik-button-primary': this.props.primary && !isSubtle,
                'ik-button-primary--subtle': this.props.primary && isSubtle,
                'ik-button-secondary': isSecondary && !isSubtle,
                'ik-button-secondary--subtle': isSecondary && isSubtle,
                'ik-button-small': this.props.small,
                'ik-button-large': this.props.large,
            }
        );

        if (icon) {
            if (icon.startsWith('iki-')) {
                icon = 'iki ' + icon;
            } else if (icon.startsWith('pi-')) {
                icon = 'pi ' + icon;
            }
        }

        const BtnInside = <>
            {icon && iconPosition === 'left' && <i className={icon.includes('pi-') || icon.includes('iki-') ? icon : 'iconf-' + icon} style={{ fontSize: this.props.iconSize ? this.props.iconSize + 'px' : null }}></i>}
            {children ?
                <span>{children}</span> : null
            }
            {icon && iconPosition === 'right' && <i className={icon.includes('pi-') || icon.includes('iki-') ? icon : 'iconf-' + icon} style={{ fontSize: this.props.iconSize ? this.props.iconSize + 'px' : null }}></i>}
            </>;

        const Btn = this.props.element === 'div' ? (
            <div ref={el => this.el = el} onClick={onClick} onContextMenu={onContextMenu} className={classes} style={style} id={id} title={title}>{BtnInside}</div>
        ) : (
            <button ref={el => this.el = el} onClick={onClick} onContextMenu={onContextMenu} className={classes} style={style} disabled={disabled || loading} type={type ?? 'button'} id={id} title={title}>{BtnInside}</button>
        );

        if (tooltip) {
            return <Tooltip tooltip={tooltip} placement='top' hideArrow={false} modifiers={tooltipModifiers} portalContainer={document.body}>{Btn}</Tooltip>;
        }
         else {
             return Btn;
        }
    }
}
